import LegalShell from "./LegalShell";
import {
  LEGAL_CONTACT_EMAIL,
  LEGAL_LAST_UPDATED,
  SUPPORT_CONTACT_EMAIL,
} from "./legalMeta";

export default function TermsPage() {
  return (
    <LegalShell title="Terms of Service" date={LEGAL_LAST_UPDATED}>
      <div className="legal-callout">
        <p>
          <strong>Please read carefully.</strong> By creating an account,
          accessing, or using Ateno, you agree to these Terms and our Privacy
          Policy.
        </p>
      </div>

      <h2>1. Scope and Acceptance</h2>
      <p>
        These Terms form a legally binding agreement between you and Ateno Inc.
        regarding your access to the Ateno platform, applications, and related
        services (the &quot;Service&quot;). If you do not agree, do not use the
        Service.
      </p>

      <h2>2. Accounts and Eligibility</h2>
      <p>
        You must provide accurate account information, maintain the security of
        your credentials, and promptly notify us of unauthorized account use.
        You are responsible for activity performed through your account.
      </p>

      <h2>3. Prohibited Conduct</h2>
      <p>
        You may not use the Service to engage in conduct that harms users,
        Ateno, or third parties. Prohibited conduct includes, without
        limitation:
      </p>
      <ul>
        <li>abuse, harassment, threats, hate, or targeted intimidation</li>
        <li>fraud, impersonation, deceptive behavior, or account abuse</li>
        <li>spam, malicious automation, scraping, or platform overloading</li>
        <li>attempted unauthorized access, security probing, or bypassing controls</li>
        <li>uploading unlawful, infringing, or rights-violating content</li>
        <li>misusing the Service in violation of laws, regulations, or policies</li>
      </ul>

      <h2>4. Moderation, Warnings, and Restrictions</h2>
      <p>
        To protect users, platform integrity, and business operations, we may
        investigate suspected misuse and take enforcement actions, including
        warnings, feature restrictions, temporary suspensions, or permanent
        account bans.
      </p>
      <p>
        Enforcement decisions may be based on abuse reports, internal review,
        technical signals, fraud or security risk indicators, policy violations,
        legal obligations, or other safety and integrity concerns.
      </p>
      <p>
        Where necessary for safety, legal compliance, or protection of our
        systems, we may remove content or restrict/disable access without prior
        notice.
      </p>

      <h2>5. Investigations and Review Requests</h2>
      <p>
        We may review account activity, metadata, content, and related records
        when investigating misuse. If your account is restricted, you may submit
        a review request to{" "}
        <a href={`mailto:${SUPPORT_CONTACT_EMAIL}`}>{SUPPORT_CONTACT_EMAIL}</a>.
        Review outcomes are determined by Ateno at our reasonable discretion.
        Submission of a request does not guarantee restoration.
      </p>

      <h2>6. Consequences of Violations</h2>
      <p>
        Violations may result in one or more consequences, including
        de-prioritized processing, disabled features, suspension, permanent ban,
        removal of content, denial of future access, and, where appropriate,
        referral to legal authorities.
      </p>

      <h2>7. Intellectual Property and User Content</h2>
      <p>
        You retain ownership of content you upload, subject to the rights
        required for us to host, process, secure, and deliver the Service. Ateno
        retains all rights in the Service, software, models, and platform
        infrastructure.
      </p>

      <h2>8. Service Availability, Disclaimers, and Liability</h2>
      <p>
        The Service is provided &quot;as is&quot; and &quot;as available.&quot;
        To the maximum extent permitted by law, Ateno disclaims implied
        warranties and is not liable for indirect, incidental, special, or
        consequential damages.
      </p>

      <h2>9. Termination</h2>
      <p>
        You may stop using the Service at any time. We may suspend or terminate
        access in accordance with these Terms. Certain provisions (including
        safety, liability, and dispute provisions) survive termination.
      </p>

      <h2>10. Changes to These Terms</h2>
      <p>
        We may update these Terms from time to time. Material updates will be
        reflected by the &quot;Last updated&quot; date and may be communicated
        through the Service or by other reasonable means.
      </p>

      <h2>11. Contact</h2>
      <div className="legal-callout">
        <p>
          Ateno Inc. · Legal Team ·{" "}
          <a href={`mailto:${LEGAL_CONTACT_EMAIL}`}>{LEGAL_CONTACT_EMAIL}</a>
        </p>
      </div>
    </LegalShell>
  );
}
